import {useEffect} from "react";
import {useAuthStore} from "@/store/auth.store";
import HomePage from "./HomePage";

const HomeRoute = () => {
  const hydrate = useAuthStore(state => state.hydrate);
  const status = useAuthStore(state => state.status);

  useEffect(() => {
    if (status === "checking") hydrate();
  }, [status, hydrate]);

  return (
    <main className="min-h-screen w-full bg-[var(--color-bg)]">
      <HomePage />
    </main>
  );
};

export default HomeRoute;
